/*
 * @Author: Teemo Ding
 * @Date: 2021-09-03 11:16:20
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-03-07 14:09:02
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCommunication/components/StatusTag/index.tsx
 */
import React from 'react';
import css from './css.module.less';
export const enum EnabledChannelsStatus {
  On = 'On',
  Off = 'Off',
}

const StatusTag = (props) => {
  const { status } = props;
  const tagColor = {
    [EnabledChannelsStatus.On]: {
      color: '#B7EB8F',
      backgroundColor: '#F6FFED',
    },
    [EnabledChannelsStatus.Off]: {
      color: '#B9BCBF',
      backgroundColor: '#F4F5F7',
    },
  };
  return status ? (
    <div
      className={css.statusTag}
      style={{
        ...(tagColor[status] || {
          color: '#1B93C5',
          backgroundColor: '#F4FCFF',
        }),
        border: `1px solid ${(tagColor[status] || {}).color || '#1B93C5'}`,
      }}>
      {status}
    </div>
  ) : null;
};

export default StatusTag;
